<template>
  <div>
    <nav aria-label="breadcrumb" class="content-block">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a href="#/simpeg-dashboard">Dashboard</a>
        </li>
        <li class="breadcrumb-item">
          <a href="#/dewas-list">Daftar {{ this.pageTitle }}</a>
          <!-- <a :href="parentPageUrl">Daftar {{ pageTitle }}</a> -->
        </li>
        <li class="breadcrumb-item active" aria-current="page">
          {{ pageTitle }}
        </li>
        <li class="breadcrumb-item">
          <a href="#/dewas-add">Tambah Data</a>
        </li>
      </ol>
    </nav>

    <LogPopupTemplate ref="logPopup" />
    <DxPopup
      :visible="popupLoginVisible"
      title="Masukkan password superadmin"
      :drag-enabled="false"
      :hide-on-outside-click="false"
      width="300"
      :height="200"
    >
      <DxValidationGroup ref="refValidationLogin">
        <DxTextBox
          :styling-mode="stylingMode"
          :label-mode="labelMode"
          width="100%"
          label="Password"
          placeholder="Password"
          v-model="formDataLogin.password"
          mode="password"
        >
          <DxValidator>
            <DxRequiredRule />
          </DxValidator>
        </DxTextBox>
      </DxValidationGroup>

      <DxToolbarItem
        widget="dxButton"
        toolbar="bottom"
        location="before"
        :options="cancelButtonOptionsLogin"
      />

      <DxToolbarItem
        widget="dxButton"
        toolbar="bottom"
        location="after"
        :options="confirmButtonOptionsLogin"
      />
    </DxPopup>

    <DxPopup
      :width="350"
      :height="250"
      :show-title="true"
      :title="`Upload Foto ${pageTitle}`"
      :drag-enabled="false"
      :hide-on-outside-click="true"
      v-model:visible="popupFotoVisible"
    >
      <DxToolbarItem
        widget="dxButton"
        toolbar="bottom"
        location="after"
        :options="btnOptionsFoto"
      />

      <template #content>
        <label for="fileUploaderFoto">Foto {{ pageTitle }}:</label>
        <DxFileUploader
          ref="fileUploaderFoto"
          accept="image/*"
          upload-mode="useForm"
          name="files"
          multiple="false"
          @value-changed="handleFileUploader($event, 'file_path')"
        >
        </DxFileUploader>

        <br />
      </template>
    </DxPopup>

    <DxPopup
      :visible="loadingVisible"
      title="Loading data..."
      :drag-enabled="false"
      :hide-on-outside-click="false"
      width="300"
      :height="130"
    >
      <div class="d-flex justify-content-center">
        <div
          class="spinner-border"
          style="width: 3rem; height: 3rem"
          role="status"
        ></div>
      </div>
    </DxPopup>

    <div class="content-block">
      <div class="row">
        <!-- <div class="editors"> -->
        <div class="editors-container">
          <div class="col">
            <h5>Detail {{ pageTitle }}</h5>
          </div>

          <div class="col" style="padding-left: 10px" v-if="dewasSource">
            <DxSelectBox
              ref="selectPegawai"
              :dataSource="dewasSource"
              valueExpr="id"
              displayExpr="display_expr"
              width="100%"
              label="Pilih Dewan Pengawas"
              placeholder="Pilih Dewan Pengawas"
              :styling-mode="stylingMode"
              :label-mode="labelMode"
              :searchEnabled="true"
              v-model="dewasId"
              @enter-key="lihatDewas"
              @item-click="lihatDewas"
              @selection-changed="lihatDewas"
            >
            </DxSelectBox>
          </div>

          <div class="col" style="padding-left: 10px" v-if="dewasSource">
            <DxButton
              @click="lihatDewas"
              text="lihat"
              styling-mode="outlined"
              type="default"
              class="validate"
              style="float: left"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="content-block">
      <div class="dx-card responsive-paddings">
        <div>
          <DxMenu
            :items="treeData"
            :show-first-submenu-mode="showFirstSubmenuModes"
            :orientation="orientation"
            :hide-submenu-on-mouse-leave="hideSubmenuOnMouseLeave"
            display-expr="text"
            @item-click="itemClick"
            selection-mode="single"
            :select-by-click="true"
          />

          <div class="title-container-pegawai">
            <div class="flag-pegawai" @click="popUpProfile($event)">
              <img
                id="imageProfile"
                ref="refImageProfile"
                :src="imageUrl"
                v-if="dataSourceDewas"
              />

              <DxTooltip
                :hide-on-outside-click="false"
                target="#imageProfile"
                show-event="mouseenter"
                hide-event="mouseleave"
              >
                Klik utk ubah foto {{ pageTitle }}
              </DxTooltip>
            </div>
            <div>
              <div class="country-name" v-if="dataSourceDewas">
                {{ dataSourceDewas.nama }}
                <span style="padding-left: 20px">
                  <DxButton
                    v-if="can('superadmin')"
                    icon="remove"
                    :text="`Hapus ${pageTitle}`"
                    @click="delDewasBtn"
                    styling-mode="outlined"
                    type="danger"
                  />
                  <DxButton
                    icon="download"
                    text="Download Data Keseluruhan"
                    @click="onExportingAll"
                    styling-mode="outlined"
                    type="default"
                  />
                  <DxButton
                    v-if="dewasId"
                    icon="clock"
                    text="Log Perubahan Data"
                    styling-mode="outlined"
                    type="default"
                    @click="this.$refs.logPopup.showAll('dewas', dewasId)"
                  />
                </span>
              </div>
              <div v-if="dataSourceDewas">
                {{ dataSourceDewas.status_aktifs_nama }}
              </div>
            </div>
          </div>
          <br />
          <DxTabPanel
            id="tabpanel"
            v-model:selected-index="tabPanelIndex"
            :data-source="tabSource"
            :animation-enabled="true"
            item-title-template="title"
            item-template="currentTemplate"
            @titleClick="tabTitleClick"
          >
            <template #title="{ data: item }">
              <span class="tab-panel-title">{{ item.text }}</span>
            </template>

            <template #tBasic>
              <div v-if="!editing && dataSourceDewas">
                <div class="table-container">
                  <table class="table borderless" style="width: 100%">
                    <tbody>
                      <tr>
                        <td><strong>Nama</strong></td>
                        <td class="padded-column">
                          {{ dataSourceDewas.nama }}
                        </td>
                        <td></td>
                        <td><strong>Tempat lahir</strong></td>
                        <td class="padded-column">
                          {{ dataSourceDewas.tempat_lahir }}
                        </td>
                      </tr>

                      <tr>
                        <td><strong>Alamat</strong></td>
                        <td class="padded-column">
                          {{ dataSourceDewas.alamat }}
                        </td>
                        <td></td>
                        <td><strong>Tgl lahir</strong></td>
                        <td class="padded-column">
                          {{ displayTgl(dataSourceDewas.tgl_lahir) }}
                          ({{ dataSourceDewas.umur }} tahun)
                        </td>
                      </tr>

                      <tr>
                        <td><strong>No. Telp</strong></td>
                        <td class="padded-column">
                          {{ dataSourceDewas.telp }}
                        </td>
                        <td></td>
                        <td><strong>Jenis kelamin</strong></td>
                        <td class="padded-column">
                          {{ dataSourceDewas.jenis_kelamin }}
                        </td>
                      </tr>
                      <tr>
                        <td><strong>Agama</strong></td>
                        <td class="padded-column">
                          {{
                            displayLookup(
                              dataSourceDewas.agama_id,
                              commonStore.agamaStore,
                            )
                          }}
                        </td>
                        <td></td>
                        <td><strong>Status aktif</strong></td>
                        <td class="padded-column">
                          {{
                            displayLookup(
                              dataSourceDewas.status_aktif_id,
                              commonStore.statusAktifStore,
                            )
                          }}
                        </td>
                      </tr>

                      <tr>
                        <td colspan="6">
                          <dx-button
                            v-if="can('pegawai-update')"
                            text="Edit"
                            @click="startEditingDewas"
                            style="float: right"
                            type="default"
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div v-if="editing && dataSourceDewas" class="editors">
                <DxValidationGroup ref="refValidationDewas">
                  <div class="row row-cols-1 row-cols-md-2">
                    <div class="col">
                      <div class="editors-container">
                        <div class="left">
                          <DxTextBox
                            :styling-mode="stylingMode"
                            :label-mode="labelMode"
                            width="100%"
                            label="Nama"
                            placeholder="Nama"
                            v-model="dataSourceDewas.nama"
                          >
                            <DxValidator>
                              <DxRequiredRule />
                            </DxValidator>
                          </DxTextBox>
                          <DxTextBox
                            :styling-mode="stylingMode"
                            :label-mode="labelMode"
                            width="100%"
                            label="Alamat"
                            placeholder="Alamat"
                            v-model="dataSourceDewas.alamat"
                          >
                          </DxTextBox>

                          <DxTextBox
                            :styling-mode="stylingMode"
                            :label-mode="labelMode"
                            width="100%"
                            label="No. telp"
                            placeholder="No. telp"
                            v-model="dataSourceDewas.telp"
                          >
                          </DxTextBox>

                          <DxSelectBox
                            :dataSource="commonStore.agamaStore"
                            valueExpr="id"
                            displayExpr="nama"
                            :searchEnabled="true"
                            searchExpr="nama"
                            search-mode="startswith"
                            :styling-mode="stylingMode"
                            :label-mode="labelMode"
                            width="100%"
                            placeholder="Agama"
                            label="Agama"
                            v-model="dataSourceDewas.agama_id"
                          >
                          </DxSelectBox>
                        </div>
                      </div>
                    </div>

                    <div class="col">
                      <div class="editors-container">
                        <div class="left">
                          <DxTextBox
                            :styling-mode="stylingMode"
                            :label-mode="labelMode"
                            width="100%"
                            label="Tempat lahir"
                            placeholder="Tempat lahir"
                            v-model="dataSourceDewas.tempat_lahir"
                          >
                          </DxTextBox>
                          <DxDateBox
                            :styling-mode="stylingMode"
                            :label-mode="labelMode"
                            :display-format="'dd/MM/yyyy'"
                            :format="'dd/MM/yyyy'"
                            width="100%"
                            placeholder="Tgl lahir"
                            label="Tgl lahir"
                            v-model="dataSourceDewas.tgl_lahir"
                          >
                            <DxValidator>
                              <DxRequiredRule />
                            </DxValidator>
                          </DxDateBox>

                          <DxSelectBox
                            :dataSource="commonStore.jenisKelaminStore"
                            valueExpr="nama"
                            displayExpr="nama"
                            :styling-mode="stylingMode"
                            :label-mode="labelMode"
                            width="100%"
                            placeholder="Jenis kelamin"
                            label="Jenis kelamin"
                            v-model="dataSourceDewas.jenis_kelamin"
                          >
                            <DxValidator>
                              <DxRequiredRule />
                            </DxValidator>
                          </DxSelectBox>
                          <DxSelectBox
                            :dataSource="commonStore.statusAktifStore"
                            valueExpr="id"
                            displayExpr="nama"
                            :searchEnabled="true"
                            searchExpr="nama"
                            search-mode="startswith"
                            :styling-mode="stylingMode"
                            :label-mode="labelMode"
                            width="100%"
                            placeholder="Status aktif"
                            label="Status aktif"
                            v-model="dataSourceDewas.status_aktif_id"
                          >
                            <DxValidator>
                              <DxRequiredRule />
                            </DxValidator>
                          </DxSelectBox>
                        </div>
                      </div>
                    </div>
                  </div>
                </DxValidationGroup>
                <div class="editors-container">
                  <!-- <div class="left"></div> -->
                  <div class="left">
                    <div class="button-container">
                      <DxButton
                        v-if="can('pegawai-update')"
                        @click="savingDewas()"
                        text="save"
                        type="default"
                        class="validate"
                        id="button-1"
                      />
                      <DxButton
                        @click="startEditingDewas"
                        text="cancel"
                        class="validate"
                        id="button-2"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div v-if="dataSourceDewas">
                <p class="text-muted font-weight-light">
                  dibuat oleh
                  {{ dataSourceDewas.created_at_text }}
                  <!-- {{ commonFunction.viewCreatedByUser(dataSourceDewas) }}, -->
                  diupdate oleh
                  <!-- {{ commonFunction.viewUpdatedByUser(dataSourceDewas) }} -->
                  {{ dataSourceDewas.updated_at_text }}
                  <dx-button
                    v-if="dewasId"
                    hint="View Log Perubahan"
                    icon="clock"
                    styling-mode="outlined"
                    :visible="true"
                    @click="this.$refs.logPopup.showBySubject(dewasId, 'Dewas')"
                    type="default"
                  />
                </p>
              </div>
            </template>

            <template #tpph>
              <DxDataGrid
                :focused-row-enabled="true"
                ref="refDataGridPph"
                :data-source="dewasPphListStore.dataSourceDewasPphList"
                :allow-column-reordering="true"
                :show-borders="true"
                :show-column-lines="false"
                :column-auto-width="true"
                :column-hiding-enabled="false"
                @exporting="onExporting($event, 'Data PPH dan PTKP')"
                :word-wrap-enabled="true"
                :height="gridHeight"
                :filter-value="filterValue"
                :filter-sync-enabled="true"
                :remote-operations="true"
                :scrolling="{
                  mode: 'virtual',
                  rowRenderingMode: 'virtual',
                  columnRenderingMode: 'virtual',
                  useNative: true,
                }"
                @init-new-row="initialPegawaiId($event, 'refDataGridPph')"
                @rowRemoving="rowRemoving('refDataGridPph')"
                @editing-start="onEditingStart"
                @edit-canceling="onEditCanceling"
                @editor-preparing="onEditorPreparing"
                @saved="onSaved()"
                @row-updating="onUpdating"
              >
                <DxHeaderFilter :visible="true" />
                <DxSorting mode="multiple" />
                <DxScrolling mode="virtual" />
                <DxFilterRow :visible="true" apply-filter="auto" />
                <DxPager
                  :visible="true"
                  :showPageSizeSelector="false"
                  :showNavigationButtons="false"
                  :show-info="true"
                  :infoText="'Page {0} of {1} ({2} items)'"
                />
                <DxPaging :enabled="true" :page-size="numberingPageSize" />
                <DxExport :enabled="true" />

                <DxEditing
                  :allow-updating="allow(can('pegawai-update'), allowUpdating)"
                  :allow-adding="allow(can('pegawai-create'), allowAdding)"
                  :allow-deleting="allow(can('pegawai-del'), allowDeleting)"
                  :new-row-position="bottom"
                  :mode="dxEditingMode"
                  v-bind="editingConfig('pph')"
                />
                <DxToolbar>
                  <DxItem location="after" template="refresh-template" />
                  <DxItem name="groupPanel" />
                  <DxItem name="addRowButton" show-text="always" />
                  <DxItem name="exportButton" />
                  <DxItem name="columnChooserButton" />
                  <DxItem name="searchPanel" />
                </DxToolbar>
                <template #refresh-template>
                  <DxButton
                    icon="refresh"
                    @click="refreshDatagrid('refDataGridPph')"
                    text="Refresh Data"
                    type="default"
                    style="float: left"
                    width="160px"
                    styling-mode="outlined"
                  ></DxButton>
                </template>
                <DxColumnFixing :enabled="true" />

                <DxColumn
                  caption="#"
                  data-field="row_number"
                  :allow-filtering="false"
                  :allow-sorting="false"
                  :allow-exporting="false"
                  :fixed="true"
                  fixed-position="left"
                  data-type="number"
                />
                <dx-column
                  data-field="dewas_id"
                  caption="Dewas ID"
                  :visible="false"
                  data-type="number"
                />
                <dx-column
                  data-field="id"
                  caption="id"
                  data-type="number"
                  :visible="false"
                />

                <DxColumn
                  data-field="status_hitung"
                  caption="Status Hitung PPH"
                  :allowHeaderFiltering="true"
                  :header-filter="{
                    dataSource: commonStore.statusSource,
                  }"
                  :dataType="'boolean'"
                  cell-template="templateStatus"
                >
                  <DxLookup
                    display-expr="nama"
                    value-expr="val"
                    :data-source="commonStore.statusStore"
                  />
                </DxColumn>

                <DxColumn
                  data-field="status"
                  caption="Status "
                  :allowHeaderFiltering="true"
                  :header-filter="{
                    dataSource: commonStore.statusSource,
                  }"
                  :dataType="'boolean'"
                  cell-template="templateStatus"
                  :visible="false"
                >
                  <DxLookup
                    display-expr="nama"
                    value-expr="val"
                    :data-source="commonStore.statusStore"
                  />
                </DxColumn>

                <template #templateStatus="{ data }">
                  <StatusTemplate :value="data.value" />
                </template>
                <DxColumn
                  data-field="tgl"
                  caption="Tgl"
                  data-type="date"
                  :display-format="'dd/MM/yyyy'"
                  :format="'dd/MM/yyyy'"
                  :allowHeaderFiltering="false"
                  sort-order="asc"
                >
                  <DxRequiredRuleDataGrid />
                </DxColumn>

                <DxColumn
                  data-field="ptkp"
                  caption="PTKP"
                  :allowHeaderFiltering="true"
                  :header-filter="{
                    dataSource: commonStore.statusPtkpSource,
                  }"
                >
                  <DxLookup
                    display-expr="nama"
                    value-expr="nama"
                    :data-source="commonStore.statusPtkpStore"
                  />
                  <DxRequiredRuleDataGrid />
                </DxColumn>

                <DxColumn
                  data-field="ter"
                  caption="TER PPH 21 (%)"
                  :allowHeaderFiltering="false"
                />

                <DxColumn
                  :allowHeaderFiltering="false"
                  :allow-filtering="false"
                  :allow-sorting="true"
                  :allow-exporting="false"
                  :allow-editing="true"
                  :allow-adding="true"
                  cell-template="fileTemplate"
                  caption="Dokumen"
                  data-field="file_path"
                  data-type="string"
                  edit-cell-template="editFileTemplate"
                >
                </DxColumn>
                <DxColumn
                  caption="Dibuat oleh"
                  :allowHeaderFiltering="false"
                  data-field="created_at_text"
                  :allowFiltering="false"
                  :allow-sorting="false"
                  :allow-exporting="false"
                  :allow-updating="false"
                />

                <DxColumn
                  caption="Diubah oleh"
                  :allowHeaderFiltering="false"
                  data-field="updated_at_text"
                  :allowFiltering="false"
                  :allow-sorting="false"
                  :allow-exporting="false"
                  :allow-updating="false"
                />

                <template #editFileTemplate="{ data }">
                  <div>
                    <DxFileUploader
                      ref="fileUploaderRef"
                      accept="*"
                      upload-mode="useForm"
                      :upload-url="arsipUploadUrl"
                      :upload-headers="serverHeader"
                      @value-changed="onFileValueChanged($event, { data })"
                      @uploaded="onUploaded($event, { data })"
                      @upload-error="onUploadError"
                    />
                  </div>
                </template>

                <template #fileTemplate="{ data }">
                  <div class="small-button-container">
                    <DxButton
                      :visible="setPrintAdaFile(data.text)"
                      @click="
                        handleClickDocument(data, 'File Data PPH dan PTKP')
                      "
                      icon="download"
                    />
                  </div>
                </template>
                <DxColumn type="buttons" :width="110">
                  <DxButtonDataGrid name="edit" />
                  <DxButtonDataGrid name="delete" />
                  <DxButtonDataGrid
                    hint="View Log Perubahan"
                    icon="clock"
                    :visible="true"
                    @click="
                      this.$refs.logPopup.showBySubject($event, 'DewasPph')
                    "
                  />
                </DxColumn>
              </DxDataGrid>
            </template>

            <template #tArsip>
              <DxDataGrid
                :focused-row-enabled="true"
                ref="refDataGridArsip"
                :data-source="arsipListStore.dataSourceArsipList"
                :allow-column-reordering="true"
                :show-borders="true"
                :show-column-lines="false"
                :column-auto-width="true"
                :column-hiding-enabled="false"
                @exporting="onExporting($event, 'Data Arsip')"
                @editing-start="onEditingStart"
                @init-new-row="initialPegawaiId($event, 'refDataGridArsip')"
                @rowRemoving="rowRemoving('refDataGridArsip')"
                @row-updating="rowUpdatingArsip"
                @edit-canceling="onEditCanceling"
                @editor-preparing="onEditorPreparing"
                @saved="onSaved()"
                :word-wrap-enabled="true"
                :height="gridHeight"
                :filter-value="filterValue"
                :filter-sync-enabled="true"
                :remote-operations="true"
                :scrolling="{
                  mode: 'virtual',
                  rowRenderingMode: 'virtual',
                  columnRenderingMode: 'virtual',
                  useNative: true,
                }"
              >
                <DxHeaderFilter :visible="true" />

                <DxScrolling mode="virtual" />
                <DxFilterRow :visible="true" apply-filter="auto" />
                <DxPager
                  :visible="true"
                  :showPageSizeSelector="false"
                  :showNavigationButtons="false"
                  :show-info="true"
                  :infoText="'Page {0} of {1} ({2} items)'"
                />
                <DxPaging :enabled="true" :page-size="numberingPageSize" />
                <DxExport :enabled="true" />
                <DxEditing
                  :allow-updating="allow(can('pegawai-update'), allowUpdating)"
                  :allow-adding="allow(can('pegawai-create'), allowAdding)"
                  :allow-deleting="allow(can('pegawai-del'), allowDeleting)"
                  :mode="dxEditingMode"
                  v-bind="editingConfig('arsip')"
                />
                <DxSorting mode="multiple" />
                <DxToolbar>
                  <DxItem location="after" template="refresh-template" />
                  <DxItem name="groupPanel" />
                  <DxItem name="addRowButton" show-text="always" />
                  <DxItem name="exportButton" />
                  <DxItem name="columnChooserButton" />
                  <DxItem name="searchPanel" />
                </DxToolbar>
                <template #refresh-template>
                  <DxButton
                    icon="refresh"
                    @click="refreshDatagrid('refDataGridArsip')"
                    text="Refresh Data"
                    type="default"
                    style="float: left"
                    width="160px"
                    styling-mode="outlined"
                  ></DxButton>
                </template>
                <DxColumnFixing :enabled="true" />

                <DxColumn
                  caption="#"
                  data-field="row_number"
                  :allow-filtering="false"
                  :allow-sorting="false"
                  :allow-exporting="false"
                  :fixed="true"
                  fixed-position="left"
                  data-type="number"
                />
                <dx-column
                  data-field="arsip_dewas_dewas_id"
                  caption="CURRENT DEWAS"
                  :visible="false"
                  :allow-exporting="false"
                >
                </dx-column>

                <template #tagBoxEditor="{ data: cellInfo }">
                  <EmployeeTagBoxComponent
                    :cell-info="cellInfo"
                    :data-source="dewasSource"
                    :data-grid-component="cellInfo.component"
                  />
                </template>

                <dx-column
                  data-field="id"
                  caption="id"
                  data-type="number"
                  :visible="true"
                />
                <dx-column
                  data-field="user_id"
                  caption="user_id"
                  data-type="number"
                  :visible="false"
                />

                <DxColumn
                  data-field="arsip_kategori_id"
                  caption="Kategori Arsip"
                  :allowHeaderFiltering="true"
                  :header-filter="{
                    dataSource:
                      commonStore.getArsipKategoriSource('crud').value,
                  }"
                >
                  <DxLookup
                    display-expr="nama"
                    value-expr="id"
                    :data-source="commonStore.arsipKategoriStore"
                  />
                  <DxRequiredRuleDataGrid />
                </DxColumn>
                <DxColumn
                  data-field="tgl"
                  caption="Tgl Arsip"
                  data-type="date"
                  :display-format="'dd/MM/yyyy'"
                  :format="'dd/MM/yyyy'"
                  :allowHeaderFiltering="false"
                >
                  <DxRequiredRuleDataGrid />
                </DxColumn>

                <DxColumn
                  data-field="nomor_arsip"
                  caption="No. Arsip"
                  :allowHeaderFiltering="false"
                >
                </DxColumn>
                <DxColumn
                  data-field="arsips_nama"
                  caption="Nama Arsip"
                  :allowHeaderFiltering="false"
                >
                  <DxRequiredRuleDataGrid />
                </DxColumn>
                <DxColumn
                  data-field="ket"
                  caption="Ket"
                  :allowHeaderFiltering="false"
                >
                </DxColumn>
                <!-- <dx-column
                  data-field="arsip_dewas_dewas_ids"
                  caption="Dewan Pengawas Bersangkutan"
                  :visible="true"
                  edit-cell-template="tagBoxEditor"
                  :cell-template="tagboxCellTemplate"
                  :allow-filtering="false"
                  :allow-sorting="false"
                  :header-filter="{
                    dataSource: commonStore.getDewasSource(dewasSource, 'crud')
                      .value,
                  }"
                >
                </dx-column> -->

                <dx-column
                  data-field="arsip_dewas_dewas_ids"
                  caption="Dewan Pengawas Bersangkutan"
                  :visible="true"
                  edit-cell-template="tagBoxEditor"
                  :cell-template="tagboxCellTemplate"
                  :allow-filtering="false"
                  :allow-sorting="false"
                  :header-filter="{
                    dataSource: commonStore.getDewasSource(dewasSource, 'crud')
                      .value,
                  }"
                >
                  <DxRequiredRuleDataGrid />
                </dx-column>

                <DxColumn
                  :allowHeaderFiltering="false"
                  :allow-filtering="false"
                  :allow-sorting="true"
                  :allow-exporting="false"
                  :allow-editing="true"
                  :allow-adding="true"
                  cell-template="fileTemplate"
                  caption="Dokumen"
                  data-field="file_path"
                  data-type="string"
                  edit-cell-template="editFileTemplate"
                >
                  <DxRequiredRuleDataGrid />
                </DxColumn>

                <DxColumn
                  caption="Dibuat oleh"
                  :allowHeaderFiltering="false"
                  data-field="created_at_text"
                  :allowFiltering="false"
                  :allow-sorting="false"
                  :allow-exporting="false"
                  :allow-updating="false"
                />

                <DxColumn
                  caption="Diubah oleh"
                  :allowHeaderFiltering="false"
                  data-field="updated_at_text"
                  :allowFiltering="false"
                  :allow-sorting="false"
                  :allow-exporting="false"
                  :allow-updating="false"
                />

                <template #editFileTemplate="{ data }">
                  <div>
                    <DxFileUploader
                      ref="fileUploaderRef"
                      accept="*"
                      upload-mode="useForm"
                      :upload-url="arsipUploadUrl"
                      :upload-headers="serverHeader"
                      @value-changed="onFileValueChanged($event, { data })"
                      @uploaded="onUploaded($event, { data })"
                      @upload-error="onUploadError"
                    />
                  </div>
                </template>

                <template #fileTemplate="{ data }">
                  <div class="small-button-container">
                    <DxButton
                      :visible="setPrintAdaFile(data.text)"
                      @click="handleClickDocument(data, 'File Arsip')"
                      icon="download"
                    />
                  </div>
                </template>
                <DxColumn type="buttons" :width="110">
                  <DxButtonDataGrid name="edit" />
                  <DxButtonDataGrid name="delete" />
                  <DxButtonDataGrid
                    hint="View Log Perubahan"
                    icon="clock"
                    :visible="true"
                    @click="
                      this.$refs.logPopup.showBySubject($event, 'Arsip')
                    "
                  />
                </DxColumn>
              </DxDataGrid>
            </template>

            <template #tPekerjaan>
              <DxDataGrid
                :focused-row-enabled="true"
                ref="refDataGridPekerjaan"
                :data-source="
                  dewasPekerjaanListStore.dataSourceDewasPekerjaanList
                "
                :allow-column-reordering="true"
                :show-borders="true"
                :show-column-lines="false"
                :column-auto-width="true"
                :column-hiding-enabled="false"
                @exporting="onExporting($event, 'Data Riwayat Pekerjaan')"
                :word-wrap-enabled="true"
                :height="gridHeight"
                :filter-value="filterValue"
                :filter-sync-enabled="true"
                :remote-operations="true"
                :scrolling="{
                  mode: 'virtual',
                  rowRenderingMode: 'virtual',
                  columnRenderingMode: 'virtual',
                  useNative: true,
                }"
                @init-new-row="initialPegawaiId($event, 'refDataGridPekerjaan')"
                @saving="savingPekerjaan"
                @rowRemoving="rowRemoving('refDataGridPekerjaan')"
                @editing-start="onEditingStart"
                @edit-canceling="onEditCanceling"
                @editor-preparing="onEditorPreparing"
                @saved="onSaved()"
                @row-updating="onUpdating"
              >
                <DxSorting mode="multiple" />
                <DxHeaderFilter :visible="true" />

                <DxScrolling mode="virtual" />
                <DxFilterRow :visible="true" apply-filter="auto" />
                <DxPager
                  :visible="true"
                  :showPageSizeSelector="false"
                  :showNavigationButtons="false"
                  :show-info="true"
                  :infoText="'Page {0} of {1} ({2} items)'"
                />
                <DxPaging :enabled="true" :page-size="numberingPageSize" />
                <DxExport :enabled="true" />
                <DxEditing
                  :allow-updating="allow(can('pegawai-update'), allowUpdating)"
                  :allow-adding="allow(can('pegawai-create'), allowAdding)"
                  :allow-deleting="allow(can('pegawai-del'), allowDeleting)"
                  :mode="dxEditingMode"
                  v-bind="editingConfig('pekerjaan')"
                />
                <DxToolbar>
                  <DxItem location="after" template="refresh-template" />
                  <DxItem name="groupPanel" />
                  <DxItem name="addRowButton" show-text="always" />
                  <DxItem name="exportButton" />
                  <DxItem name="columnChooserButton" />
                  <DxItem name="searchPanel" />
                </DxToolbar>
                <template #refresh-template>
                  <DxButton
                    icon="refresh"
                    @click="refreshDatagrid('refDataGridPekerjaan')"
                    text="Refresh Data"
                    type="default"
                    style="float: left"
                    width="160px"
                    styling-mode="outlined"
                  ></DxButton>
                </template>
                <DxColumnFixing :enabled="true" />

                <DxColumn
                  caption="#"
                  data-field="row_number"
                  :allow-filtering="false"
                  :allow-sorting="false"
                  :allow-exporting="false"
                  :fixed="true"
                  fixed-position="left"
                  data-type="number"
                />
                <dx-column
                  data-field="dewas_id"
                  caption="Dewas ID"
                  :visible="false"
                  data-type="number"
                />
                <dx-column
                  data-field="id"
                  caption="id"
                  data-type="number"
                  :visible="false"
                />
                <DxColumn
                  data-field="status"
                  caption="Status"
                  :allowHeaderFiltering="true"
                  :header-filter="{ dataSource: commonStore.statusSource }"
                  cell-template="templateStatus"
                  :visible="false"
                >
                  <!--  -->
                  <DxLookup
                    display-expr="nama"
                    value-expr="val"
                    :data-source="commonStore.statusStore"
                  />
                </DxColumn>

                <DxColumn
                  data-field="jabatan_id"
                  caption="Jabatan"
                  :allowHeaderFiltering="true"
                  :header-filter="{
                    dataSource: commonStore.getJabatanDewasSource('crud').value,
                  }"
                >
                  <DxLookup
                    display-expr="nama"
                    value-expr="id"
                    :data-source="commonStore.jabatanDewasStore"
                  />
                  <DxRequiredRuleDataGrid />
                </DxColumn>

                <DxColumn
                  data-field="tgl_mulai_bekerja"
                  caption="Tgl Mulai"
                  data-type="date"
                  :display-format="'dd/MM/yyyy'"
                  :format="'dd/MM/yyyy'"
                  :allowHeaderFiltering="false"
                  sort-order="asc"
                >
                  <DxRequiredRuleDataGrid
                /></DxColumn>
                <DxColumn
                  data-field="tgl_akhir_bekerja"
                  caption="Tgl Akhir"
                  data-type="date"
                  :display-format="'dd/MM/yyyy'"
                  :format="'dd/MM/yyyy'"
                  :allowHeaderFiltering="false"
                />

                <template #templateStatus="{ data }">
                  <StatusTemplate :value="data.value" />
                </template>

                <DxColumn
                  :allowHeaderFiltering="false"
                  :allow-filtering="false"
                  :allow-sorting="true"
                  :allow-exporting="false"
                  :allow-editing="true"
                  :allow-adding="true"
                  cell-template="fileTemplate"
                  caption="Dokumen"
                  data-field="file_path"
                  data-type="string"
                  edit-cell-template="editFileTemplate"
                >
                </DxColumn>
                <DxColumn
                  caption="Dibuat oleh"
                  :allowHeaderFiltering="false"
                  data-field="created_at_text"
                  :allowFiltering="false"
                  :allow-sorting="false"
                  :allow-exporting="false"
                  :allow-updating="false"
                />

                <DxColumn
                  caption="Diubah oleh"
                  :allowHeaderFiltering="false"
                  data-field="updated_at_text"
                  :allowFiltering="false"
                  :allow-sorting="false"
                  :allow-exporting="false"
                  :allow-updating="false"
                />
                <template #editFileTemplate="{ data }">
                  <div>
                    <DxFileUploader
                      ref="fileUploaderRef"
                      accept="*"
                      upload-mode="useForm"
                      :upload-url="arsipUploadUrl"
                      :upload-headers="serverHeader"
                      @value-changed="onFileValueChanged($event, { data })"
                      @uploaded="onUploaded($event, { data })"
                      @upload-error="onUploadError"
                    />
                  </div>
                </template>

                <template #fileTemplate="{ data }">
                  <div class="small-button-container">
                    <DxButton
                      :visible="setPrintAdaFile(data.text)"
                      @click="
                        handleClickDocument(data, 'File Riwayat Pekerjaan')
                      "
                      icon="download"
                    />
                  </div>
                </template>
                <DxColumn type="buttons" :width="110">
                  <DxButtonDataGrid name="edit" />
                  <DxButtonDataGrid name="delete" />
                  <DxButtonDataGrid
                    hint="View Log Perubahan"
                    icon="clock"
                    :visible="true"
                    @click="
                      this.$refs.logPopup.showBySubject(
                        $event,
                        'DewasRiwayatPekerjaan',
                      )
                    "
                  />
                </DxColumn>
              </DxDataGrid>
            </template>
          </DxTabPanel>
        </div>
      </div>
    </div>

    <div class="content-block">
      <div class="row">
        <div class="editors-container">
          <div class="col" style="padding-left: 10px">
            <DxSelectBox
              ref="selectDxediting"
              :dataSource="dxEditingSource"
              valueExpr="val"
              displayExpr="nama"
              width="10%"
              label="Editing Mode"
              placeholder="Editing Mode"
              :styling-mode="stylingMode"
              :label-mode="labelMode"
              :searchEnabled="true"
              v-model="dxEditingMode"
            >
            </DxSelectBox>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LogPopupTemplate from "./LogPopupTemplate.vue";
import router from "@/router";
import DxValidationGroup from "devextreme-vue/validation-group";
import EmployeeTagBoxComponent from "./EmployeeTagBoxComponent.vue";
import auth from "@/auth";
import * as XLSX from "xlsx";
import notify from "devextreme/ui/notify";
import DxSelectBox from "devextreme-vue/select-box";
import { DateTime } from "luxon";
import StatusTemplate from "./StatusTemplate.vue";
import DxTabPanel from "devextreme-vue/tab-panel";
import { DxTooltip } from "devextreme-vue/tooltip";
import DxMenu from "devextreme-vue/menu";
import { BASE_URL } from "@/global-constants";
import { useDewasPphListStore } from "@/stores/views/dewas-pph-list-store";
import { useDewasListStore } from "@/stores/views/dewas-list-store";
import { useDewasPekerjaanListStore } from "@/stores/views/dewas-pekerjaan-list-store";
import { useArsipListStore } from "@/stores/views/arsip-list-store";
import { useCommonStore } from "@/stores/utility/common-store2";
import * as commonFunction from "@/utils/common-function.js";
// import { confirm } from "devextreme/ui/dialog";
import can from "@/haspermission";
import axios from "axios";
import api from "@/api";
import { API_BASE_URL } from "@/global-constants";
import DxButton from "devextreme-vue/button";
import _ from "lodash";
import { DxPopup, DxToolbarItem } from "devextreme-vue/popup";
import { DxValidator, DxRequiredRule } from "devextreme-vue/validator";
import { DxFileUploader } from "devextreme-vue/file-uploader";

import {
  DxDataGrid,
  DxColumn,
  DxEditing,
  DxPaging,
  DxFilterRow,
  DxLookup,
  DxPager,
  DxColumnFixing,
  DxExport,
  DxToolbar,
  DxItem,
  DxScrolling,
  // DxButton as DxButtonDatagrid,
  // DxSummary,
  // DxTotalItem,
  DxHeaderFilter,
  DxSorting,
  DxRequiredRule as DxRequiredRuleDataGrid,
  DxButton as DxButtonDataGrid,
} from "devextreme-vue/data-grid";
import { exportDataGrid } from "devextreme/excel_exporter";
import { Workbook } from "exceljs";
import saveAs from "file-saver";
import DxTextBox from "devextreme-vue/text-box";
import DxDateBox from "devextreme-vue/date-box";
import { confirm } from "devextreme/ui/dialog";
// import { isDate } from "lodash";

function formatDateDisplay(dateOri) {
  const date = DateTime.fromJSDate(new Date(dateOri));
  return date.toFormat("dd/MM/yyyy");
}

const tabMenus = [
  {
    items: [
      { text: "Data Personal", template: "tBasic", ref: "" },
      {
        text: "Data PPH & PTKP",
        template: "tpph",
        ref: "refDataGridPph",
      },
      {
        text: "Arsip",
        template: "tArsip",
        ref: "refDataGridArsip",
      },
    ],
  },
  {
    items: [
      {
        text: "riwayat Pekerjaan",
        template: "tPekerjaan",
        ref: "refDataGridPekerjaan",
      },
    ],
  },
];

export default {
  components: {
    LogPopupTemplate,
    DxFileUploader,
    DxSelectBox,
    DxTabPanel,
    DxTooltip,
    DxMenu,
    // confirm,
    DxTextBox,
    DxDateBox,
    DxDataGrid,
    // eslint-disable-next-line
    DxColumn,
    DxPager,
    DxPaging,
    DxEditing,
    DxFilterRow,
    // eslint-disable-next-line
    DxLookup,
    DxColumnFixing,
    // DxSelection,
    DxExport,
    DxToolbar,
    DxButton,
    // DxButtonDatagrid,

    DxPopup,
    DxToolbarItem,
    DxItem,

    // DxSummary,
    // DxTotalItem,
    DxScrolling,
    DxHeaderFilter,
    StatusTemplate,
    DxSorting,
    DxRequiredRuleDataGrid,
    DxValidator,
    DxRequiredRule,
    EmployeeTagBoxComponent,
    DxValidationGroup,
    DxButtonDataGrid,
  },
  setup() {
    const dewasPphListStore = useDewasPphListStore();
    const dewasPekerjaanListStore = useDewasPekerjaanListStore();
    const dewasListStore = useDewasListStore();
    const arsipListStore = useArsipListStore();

    const commonStore = useCommonStore();

    return {
      dewasPphListStore,
      dewasPekerjaanListStore,
      dewasListStore,
      arsipListStore,
      commonStore,
      commonFunction,
    };
  },
  data() {
    const showSubmenuModes = [
      {
        name: "onHover",
        delay: { show: 0, hide: 500 },
      },
      {
        name: "onClick",
        delay: { show: 0, hide: 300 },
      },
    ];

    return {
      logPopupRef: null,
      pageTitle: "",
      localValue: [],
      popupFileVisible: false,
      popupFileTitle: null,
      btnOptionsFoto: {
        text: "Upload Foto",
        onClick: () => {
          this.uploadFile("refImageProfile", "dewas", this.dewasId, "upload");
        },
      },

      imageUrl: null,
      loadingVisible: false,
      dewasSource: null,
      dxEditingMode: "popup", //row
      dewasId: parseInt(this.$route.query.id, 10),
      serverUrl: `${BASE_URL}/`,
      fileFoto: null,
      file: null,
      fileName: null,
      filePath: null,
      fileUrl: null,
      fileTitle: null,
      fileTableId: null,
      fileTable: null,
      fileTableRef: null,

      filterValue: [],

      stylingMode: "underlined",
      //outlined, filled, underlined
      labelMode: "floating",

      numberingPageSize: 100,
      popupLoginVisible: false,
      buttonFilterPintasanVisible: false,
      dataSourceDewasPekerjaan: null,

      dataSourceDewas: null,

      currentTemplate: "tBasic",
      treeData: [
        {
          id: 1,
          text: "Data Personal",
          templateIndex: 0,
          selected: true,
        },
        {
          id: 2,
          text: "Data Pekerjaan",
          templateIndex: 1,
          selected: false,
        },
      ],
      showSubmenuModes,
      showFirstSubmenuModes: showSubmenuModes[1],
      orientation: "horizontal",
      hideSubmenuOnMouseLeave: false,
      tabPanelIndex: 0,
      tabMenus: tabMenus,
      tabSource: tabMenus[0].items,
      filterPegawaiId: null,
      editing: false,
      allowUpdating: true,
      allowAdding: true,
      allowDeleting: true,
      popupFotoVisible: false,
      popupPrediksiVisible: false,
      popupPrediksiTetapkanVisible: false,
      popupPrediksiTitle: null,
      popupPrediksiTable: null,
      formDataLogin: {
        password: "",
      },
      isPengajuanPenetapanDisabledKGB: true,
      isPengajuanPenetapanDisabledKP: true,

      dxEditingSource: [
        { val: "row", nama: "Baris" },
        { val: "popup", nama: "Form popup" },
      ],
      arsip_pegawais_pegawai_ids: null,
      tagBoxSetInitialValue: [],

      confirmButtonOptionsLogin: {
        text: "Konfirmasi",
        // useSubmitBehavior: "true",
        onClick: () => {
          this.onSubmitLogin();
        },
      },

      cancelButtonOptionsLogin: {
        text: "Close",
        type: "danger",
        onClick: () => {
          this.popupLoginVisible = false;
          this.formDataLogin = {
            password: "",
          };
        },
      },
    };
  },

  // watch: {
  //   "data.data.arsip_pegawais_pegawai_ids": {
  //     handler(newValue) {
  //       this.localValue = newValue;
  //     },
  //     immediate: true,
  //   },
  // },

  async created() {
    await this.commonStore.preloadStores();
    // await this.loadData();
    let tempA = await this.dewasListStore.dataSourceDewasListCoba(null, [
      {
        selector: "dewas.nama",
        desc: false,
      },
    ]);
    tempA.data.unshift({ id: null, display_expr: null });

    this.dewasSource = tempA.data; //all pegawai
  },

  async mounted() {
    await this.loadData();
  },

  computed: {
    gridHeight() {
      // Calculate grid height based on your requirements
      return "60vh"; // Set the height to fill the viewport vertically
    },
  },

  methods: {
    tagboxCellTemplate(cellElement, cellInfo) {
      cellElement.innerHTML = ""; // Clear the cell content
      const wrapper = document.createElement("div"); // Create a wrapper div

      cellInfo.data.arsip_dewas_dewas_ids.forEach((id) => {
        const dewas = this.dewasSource.find((dewas) => dewas.id === id);

        if (dewas) {
          const badge = document.createElement("span"); // Create a span for the badge
          badge.className = "badge badge-primary mr-1"; // Add Bootstrap classes
          badge.style.backgroundColor = "#e0e0e0"; // Bootstrap primary color
          badge.style.color = "#333333";
          badge.style.padding = "0.4em 0.8em";
          badge.style.borderRadius = "0.25rem";
          badge.style.marginRight = "0.25rem";
          badge.style.display = "inline-block";
          badge.style.fontSize = "0.875rem";
          badge.textContent = dewas.nama; // Set the employee name as the badge content

          // Add click event listener to call onItemClick
          badge.addEventListener("click", () => {
            this.onItemDewasBersangkutanClick(dewas.id);
          });

          // Optionally, add cursor pointer to indicate it's clickable
          badge.style.cursor = "pointer";

          badge.addEventListener("mouseover", () => {
            badge.style.backgroundColor = "#333333"; // Darker background on hover
            badge.style.color = "#ffffff"; // White text on hover
          });

          badge.addEventListener("mouseout", () => {
            badge.style.backgroundColor = "#e0e0e0"; // Original background color
            badge.style.color = "#333333"; // Original text color
          });

          wrapper.appendChild(badge); // Append the badge to the wrapper
        }
      });

      cellElement.appendChild(wrapper); // Append the wrapper to the cell element
    },

    onItemDewasBersangkutanClick(dewasId) {
      const url = this.$router.resolve({
        name: "dewas-detail",
        query: { id: dewasId },
      }).href;
      window.open(url, "_blank");
    },

    initialPegawaiId(event, table) {
      this.file = null;
      this.fileName = null;
      this.filePath = null;

      if (table == "refDataGridPekerjaan") {
        event.data.status = false;
      }

      if (table == "refDataGridPph") {
        event.data.status = false;
      }

      if (table == "refDataGridArsip") {
        event.data.arsip_dewas_dewas_id = this.dewasId;
        event.data.arsip_dewas_dewas_ids = [this.dewasId];
        event.data.user_id = auth.getUser().id;

        // event.data.user_id = auth.getUser().id;
      } else event.data.dewas_id = this.dewasId;

      event.data.created_by_user_id = auth.getUser().id;
    },

    async savingDewas() {
      const result = this.$refs.refValidationDewas.instance.validate();
      if (result.isValid) {
        this.dataSourceDewas.tgl_lahir = this.formatDateISO(
          this.dataSourceDewas.tgl_lahir,
        );

        this.dataSourceDewas.updated_by_user_id = auth.getUser().id;
        this.dataSourceDewas.updated_by_user_name = auth.getUser().name;
        var savingResponse =
          await this.dewasListStore.dataSourceDewasListUpdate(
            this.dewasId,
            this.dataSourceDewas,
          );
        if (savingResponse.status) {
          this.dataSourceDewas = savingResponse.data;
          this.dataSourceDewas.umur = this.commonFunction.hitungUmur(
            this.dataSourceDewas.tgl_lahir,
          );
          notify("Perubahan data berhasil disimpan", "success");
          this.editing = false;
        } else {
          notify(
            "Perubahan data gagal disimpan: " + savingResponse.message,
            "error",
          );
        }

        // await store.update(key, values);
        // dataSourcePegawaiList.value.reload();
      }
    },

    onUpdating(e) {
      e.newData.updated_by_user_id = auth.getUser().id;
    },

    async onSubmitLogin() {
      const result = this.$refs.refValidationLogin.instance.validate();
      if (!result.isValid) return;

      //sudah valid, lakukan cek login
      const login = await auth.confirmPassword(
        auth.getUser().email,
        this.formDataLogin.password,
      );

      if (!login.isOk) {
        notify("Password Salah", "error", 2000);
      } else {
        this.popupLoginVisible = false;
        const response = await this.dewasListStore.dataSourceDewasListDelete(
          this.dewasId,
        );

        notify(response.message, response.notify_type);

        if (response.status) {
          router.push({
            name: "dewas-list",
          });
        }
        // lakukan delete
      }
    },
    delDewasBtn() {
      this.formDataLogin.password = "";
      let result = confirm(
        "<strong>Yakin menghapus data Dewan Pengawas?</strong> <br>Semua data bersangkutan akan dihapus termasuk data personal dan pekerjaan",
        "Konfirmasi Hapus Dewan Pengawas",
      );
      result.then((dialogResult) => {
        if (dialogResult) {
          //login ulang
          this.popupLoginVisible = true;
        }
      });
    },

    onEditorPreparing(e) {
      if (e.parentType == "filterRow" && e.allowHeaderFiltering) {
        e.editorName = "dxTextBox";
        e.editorOptions.disabled = true;
        e.allowFiltering = false;
      }
    },
    uuidv4() {
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
        /[xy]/g,
        function (c) {
          var r = (Math.random() * 16) | 0,
            v = c === "x" ? r : (r & 0x3) | 0x8;
          return v.toString(16);
        },
      );
    },
    onFileValueChanged(e, cellInfo) {
      const uploadButton = e.element.querySelector(
        ".dx-fileuploader-upload-button",
      );
      const fileContainer = e.element.querySelector(
        ".dx-fileuploader-files-container",
      );
      if (uploadButton) {
        uploadButton.style.display = "none"; // Hide the upload button
      }
      if (fileContainer) {
        fileContainer.style.display = "block"; // Hide the file container
      }

      if (e.value && e.value[0]) {
        const fileNameTemp = e.value[0].name;
        const fileExtension = fileNameTemp.substring(
          fileNameTemp.lastIndexOf(".") + 1,
        );
        this.file = e.value[0];
        var guid = this.uuidv4();
        this.fileName = guid + "." + fileExtension;
        this.filePath = "files/" + this.fileName;
        cellInfo.data.setValue(this.filePath);
      }
    },

    onSaved() {
      if (!this.file) return;
      const formData = new FormData();
      formData.append("fileName", this.fileName);
      formData.append("file", this.file);

      const config = {
        headers: {
          Authorization: api.defaults.headers.common["Authorization"],
          "content-type": "multipart/form-data",
        },
      };
      axios
        .post(`${API_BASE_URL}/arsip/upload_store`, formData, config)
        .then((response) => {
          notify(response.data.message, response.data.notify_type);
          this.file = null;
          this.fileName = null;
          this.filePath = null;
        })
        .catch((error) => {
          this.file = null;
          this.fileName = null;
          this.filePath = null;
          notify("Gagal upload file", "error");
          console.log(error);
        });
    },

    onEditCanceling() {
      this.file = null;
      this.fileName = null;
      this.filePath = null;
    },

    //TODO: KETIKA TAGBOX VALUE CHANGED, theres no trigger to update the datagrid!!

    async downloadFile() {
      if (this.fileUrl === null || this.fileUrl === "") {
        notify("File tidak ada", "error");
        return;
      }

      try {
        const response = await axios.post(
          `${API_BASE_URL}/arsip/download`,
          { file_path: this.fileUrl },
          {
            responseType: "blob",
            headers: {
              Authorization: api.defaults.headers.common["Authorization"],
            },
          },
        );
        const blob = new Blob([response.data], {
          type: response.headers["content-type"],
        });

        // Extract file extension from Content-Disposition header
        const contentDisposition = response.headers["content-disposition"];
        const urlParts = this.fileUrl.split(".");
        const extension =
          urlParts.length > 1 ? urlParts[urlParts.length - 1] : "";
        let filename =
          "Arsip Dewan Pengawas - " +
          this.dataSourceDewas.nama +
          " - " +
          this.fileTitle +
          " - " +
          this.fileTableId +
          "." +
          extension;

        if (contentDisposition) {
          const match = contentDisposition.match(/filename="?([^"]+)"?/);
          if (match && match[1]) {
            filename = match[1];
          }
        }

        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", filename);

        // Append the link to the body (required for Firefox)
        document.body.appendChild(link);

        // Trigger the download
        link.click();

        // Cleanup
        window.URL.revokeObjectURL(url);
        document.body.removeChild(link);
      } catch (error) {
        console.log(error);
        notify("Dokumen gagal didownload.", "error");
      }

      return;
    },

    handleClickDocument(e, title) {
      if (e.data.file_path !== null) {
        this.fileUrl = e.data.file_path;
        if (title === "File Arsip") {
          title =
            title + " - " + e.data.arsip_kategoris_nama + " - " + e.data.nama;
        }

        this.fileTitle = title;
        this.fileTableId = e.data.id;
        this.downloadFile();
      }
      // window.open(
      //   this.serverUrl + e.data.file_path,
      //   "_blank",
      //   "location=yes"
      // );
    },

    printAdaFile(e) {
      if (_.isEmpty(e)) return;
      else return "Ada ";
    },
    uploadFile(tableRef, tableName, id, action) {
      const config = {
        headers: {
          Authorization: api.defaults.headers.common["Authorization"],
          "content-type": "multipart/form-data",
        },
      };
      if (!this.file && action === "upload") {
        notify("File belum dipilih", "error");
        return;
      }
      const formData = new FormData();
      formData.append("id", id);
      formData.append("table", tableName);
      formData.append("action", action);
      formData.append("file", this.file);

      axios
        .post(`${API_BASE_URL}/arsip/upload`, formData, config)
        .then((response) => {
          if (tableName === "dewas") {
            this.imageUrl = this.serverUrl + response.data.file_path;
            this.popupFotoVisible = false;
          } else {
            this.$refs[tableRef].instance.refresh();
            this.popupVisible = false;
          }
          notify(response.data.message, response.data.notify_type);

          this.file = null;
        })
        .catch((error) => {
          this.file = null;
          notify("Gagal upload file", "error");
          console.log(error);
        });
    },
    handleFileUploader(e) {
      // if (column == "pegawai_foto") this.fileFoto = e.value[0];
      // if (column == "file_path") {
      //   this.file = e.value[0];
      // }

      this.file = e.value[0];
    },
    popUpProfile() {
      if (this.can("pegawai-update")) this.popupFotoVisible = true;
    },
    prepExcelTgl(tgl) {
      if (tgl === null) return null;

      const dateObj = DateTime.fromISO(tgl);
      return dateObj.setLocale("id").toLocaleString({
        day: "numeric",
        month: "long",
        year: "numeric",
      });
    },
    prepExcelCapeg(capeg) {
      if (capeg) return "80%";
      return "";
    },
    prepExcelExpand(tableName, colName) {
      //misal agama.nama, ketika agama = null, maka nama akan error
      if (tableName === null) return null;
      return tableName[colName];
    },
    prepExcelBool(val) {
      if (val) return "Aktif";
      return "Tidak Aktif";
    },
    wbAoa(worksheet, text, cell) {
      XLSX.utils.sheet_add_aoa(worksheet, [[text]], {
        origin: cell,
      });
    },
    wbContentDewas(workbook, sheetName, row, data) {
      var ws = workbook.Sheets[sheetName];
      this.wbAoa(ws, "Data " + this.pageTitle, "A" + row);
      row += 2;
      this.wbAoa(ws, "Nama:", "A" + row);
      this.wbAoa(ws, data.nama, "B" + row);
      this.wbAoa(ws, "Tempat Lahir:", "D" + row);
      this.wbAoa(ws, data.tempat_lahir, "E" + row);

      row += 1;
      this.wbAoa(ws, "Alamat:", "A" + row);
      this.wbAoa(ws, data.alamat, "B" + row);
      this.wbAoa(ws, "Tgl Lahir:", "D" + row);
      this.wbAoa(
        ws,
        this.prepExcelTgl(data.tgl_lahir) + " (" + data.umur + " tahun)",
        "E" + row,
      );

      row += 1;
      this.wbAoa(ws, "No. Telp:", "A" + row);
      this.wbAoa(ws, data.telp, "B" + row);
      this.wbAoa(ws, "Jenis Kelamin:", "D" + row);
      this.wbAoa(ws, data.jenis_kelamin, "E" + row);

      row += 1;

      this.wbAoa(ws, "Agama:", "A" + row);
      this.wbAoa(ws, this.prepExcelExpand(data.agama, "nama"), "B" + row);
      this.wbAoa(ws, "Status Aktif:", "D" + row);
      this.wbAoa(ws, data.status_aktif.nama, "E" + row);
    },

    wbContentPph(workbook, sheetName, row, data) {
      var ws = workbook.Sheets[sheetName];

      var numbering = 1;
      this.wbAoa(ws, "Data PPH dan PTKP", "A" + row);
      row += 2;
      this.wbAoa(ws, "No.", "A" + row);
      this.wbAoa(ws, "Status Hitung PPH", "B" + row);
      this.wbAoa(ws, "Tgl", "C" + row);
      this.wbAoa(ws, "PTKP", "D" + row);
      this.wbAoa(ws, "TER PPH 21 (%)", "E" + row);

      row += 1;
      data.forEach((e) => {
        this.wbAoa(ws, numbering, "A" + row);
        this.wbAoa(ws, this.prepExcelBool(e.status), "B" + row);
        this.wbAoa(ws, this.prepExcelTgl(e.tgl), "C" + row);
        this.wbAoa(ws, e.ptkp, "D" + row);
        this.wbAoa(ws, e.ter, "E" + row);
        numbering += 1;
        row += 1;
      }); //endofforeach
    },

    wbContentPekerjaan(workbook, sheetName, row, data) {
      var ws = workbook.Sheets[sheetName];

      var numbering = 1;
      this.wbAoa(ws, "Riwayat Pekerjaan", "A" + row);
      row += 2;
      this.wbAoa(ws, "No.", "A" + row);
      this.wbAoa(ws, "Jabatan", "B" + row);
      this.wbAoa(ws, "Tgl Mulai", "C" + row);
      this.wbAoa(ws, "Tgl Akhir", "D" + row);
      row += 1;
      data.forEach((e) => {
        this.wbAoa(ws, numbering, "A" + row);
        this.wbAoa(ws, this.prepExcelExpand(e.jabatan, "nama"), "B" + row);
        this.wbAoa(ws, this.prepExcelTgl(e.tgl_mulai_bekerja), "C" + row);
        this.wbAoa(ws, this.prepExcelTgl(e.tgl_akhir_bekerja), "D" + row);

        numbering += 1;
        row += 1;
      }); //endofforeach
    },

    async onExportingAll() {
      const config = {
        headers: {
          Authorization: api.defaults.headers.common["Authorization"],
          "content-type": "application/json",
        },
      };
      const data = {
        dewasId: this.dewasId,
      };
      this.loadingVisible = true;
      const response = await axios.post(
        `${API_BASE_URL}/export_data_dewas_all`,
        data,
        config,
      );
      this.loadingVisible = false;
      const dataDewas = response.data.dewas;
      const dataPph = response.data.pphs;
      const dataPekerjaan = response.data.pekerjaans;

      const workbook = XLSX.utils.book_new();
      const sheetNameDewas = "Data " + this.pageTitle;
      const sheetNamePph = "Data PPH";
      const sheetNamePekerjaan = "Riwayat Pekerjaan";
      XLSX.utils.book_append_sheet(workbook, {}, sheetNameDewas);
      XLSX.utils.book_append_sheet(workbook, {}, sheetNamePph);
      XLSX.utils.book_append_sheet(workbook, {}, sheetNamePekerjaan);

      var row = 3;

      //===========================datapegawai===========================
      this.wbContentDewas(workbook, sheetNameDewas, row, dataDewas);
      /////////////////////////////endofdatapegawai//////////////////////
      //===========================datapph===========================
      this.wbContentPph(workbook, sheetNamePph, row, dataPph);
      /////////////////////////////endofdatapph//////////////////////

      //===========================datapegawai===========================
      this.wbContentPekerjaan(workbook, sheetNamePekerjaan, row, dataPekerjaan);
      /////////////////////////////endofdatapegawai//////////////////////

      XLSX.writeFile(
        workbook,
        "Data " + this.pageTitle + " " + this.dataSourceDewas.nama + ".xlsx",
      );
    },

    async lihatDewas() {
      await this.loadData();
      const refPekerjaan = this.$refs["refDataGridPekerjaan"];
      const refArsip = this.$refs["refDataGridArsip"];
      const refDewasPph = this.$refs["refDataGridDewasPph"];

      if (refArsip) {
        refArsip.instance.getDataSource().reload();
      }
      if (refDewasPph) {
        refDewasPph.instance.getDataSource().reload();
      }

      if (refPekerjaan) {
        refPekerjaan.instance.getDataSource().reload();
      }
    },

    async loadData() {
      this.loadingVisible = true;
      this.filterDewasId = ["dewas_id", "=", this.dewasId];

      let temp = await this.dewasListStore.dataSourceDewasListCoba([
        "dewas.id",
        "=",
        this.dewasId,
      ]); //ini akan return berupa array, bukan source

      this.dataSourceDewas = temp.data[0];
      this.pageTitle = "Sekretariat Dewan Pengawas";
      if (this.dataSourceDewas.is_dewas) {
        this.pageTitle = "Dewan Pengawas";
      }
      document.title =
        this.dataSourceDewas.nama + " - Detail " + this.pageTitle;

      // this.dataSourceNaikPangkatPrediksi = this.setPrediksiDataSource(
      //   "naikPangkat",
      //   temp.data[0]
      // );
      this.imageUrl = this.serverUrl + this.dataSourceDewas.file_path;

      this.dewasPphListStore.dataSourceDewasPphList.filter(this.filterDewasId);
      this.dewasPekerjaanListStore.dataSourceDewasPekerjaanList.filter(
        this.filterDewasId,
      );
      this.arsipListStore.dataSourceArsipList.filter([
        "arsip_dewas.dewas_id",
        "=",
        this.dewasId,
      ]);
      this.loadingVisible = false;
    },

    formatDateISO(dateOri) {
      if (!dateOri) return null;
      const date = DateTime.fromJSDate(new Date(dateOri));
      return date.toFormat("yyyy-MM-dd");
    },

    startEditingDewas() {
      if (this.editing) this.editing = false;
      else this.editing = true;
    },
    rowRemoving(table) {
      let dataGrid = this.$refs[table].instance;
      dataGrid.clearSelection();
      dataGrid.option("focusedRowIndex", -1);
    },

    validateOnlyOneStatusAktifPekerjaan(e, statusJabatan) {
      const countStatusFromDS = _.size(
        _.filter(e.component.getDataSource().items(), {
          status: true,
          status_jabatan: statusJabatan,
        }),
      );
      let countStatusFromChanges = 0;

      if (e.changes[0] && typeof e.changes[0].data === "object") {
        if (
          //hanya ada status di changes
          "status" in e.changes[0].data &&
          !("status_jabatan" in e.changes[0].data)
        ) {
          if (e.changes[0].data.status) countStatusFromChanges = 1;
        }
        if (
          //ada status dan status_jabatan di changes
          "status" in e.changes[0].data &&
          "status_jabatan" in e.changes[0].data
        ) {
          if (e.changes[0].data.status) countStatusFromChanges = 1;
        }
        if (
          //hanya ada status_jabatan di changes
          "status_jabatan" in e.changes[0].data &&
          !("status" in e.changes[0].data)
        ) {
          countStatusFromChanges = parseInt(
            _.size(
              _.filter(e.component.getDataSource().items(), {
                id: e.changes[0].key,
                status: true,
              }),
            ),
          );
          //SEARCHING INSIDE DATASOURCE YANG LAMA, TO GET STATUS KARENA STATUS TIDAK ADA DALAM CHANGES
        }
      }

      const totalAktif =
        parseInt(countStatusFromChanges) + parseInt(countStatusFromDS);
      if (totalAktif > 1) return false; //TODO: artinya ada lebih dari 1 aktif
      return true;
    },

    validateOnlyOneStatusAktif(e) {
      const countStatusFromDS = _.size(
        _.filter(e.component.getDataSource().items(), { status: true }),
      );
      let countStatusFromChanges = 0;

      if (
        e.changes[0] &&
        typeof e.changes[0].data === "object" &&
        "status" in e.changes[0].data
      ) {
        if (e.changes[0].data.status) countStatusFromChanges = 1;
      }

      const totalAktif =
        parseInt(countStatusFromChanges) + parseInt(countStatusFromDS);
      if (totalAktif > 1) return false; //TODO: artinya ada lebih dari 1 aktif
      return true;
    },

    editingConfig(table) {
      if (this.dxEditingMode === "popup") {
        return {
          form: this.formConfig(table),
        };
      }
      return {};
    },
    formConfig(table) {
      const tables = {
        naikpangkat: [
          // "status",
          "tgl",
          "golongan_id",
          "capeg",
          "tipe",
          "masa_kerja",
          "masa_kerja_bulan",
          "ket",
          "file_path",
        ],
        kgb: [
          // "status",
          "tgl",
          "masa_kerja",
          "masa_kerja_bulan",
          "ket",
          "file_path",
        ],
        transport: [
          // "status",
          "tipe",
          "plat_no",
          "tgl_awal",
          "tgl_akhir",
          "file_path",
        ],
        pekerjaan: [
          "jabatan_id",
          "tgl_mulai_bekerja",
          "tgl_akhir_bekerja",
          "file_path",
        ],
        pendidikan: [
          "status_penyesuaian",
          "tgl_penyesuaian",
          "pendidikan_jenjang_id",
          "institusi",
          "fakultas",
          "jurusan",
          "ipk",
          "tahun_mulai",
          "tahun_lulus",
          "ijazah_no",
          "ijazah_tgl",
          "file_path",
        ],
        pph: ["status_hitung", "tgl", "ptkp", "ter", "file_path"],
        keluarga: [
          "keluarga_hub_id",
          "status_tertanggung",
          "riwayat_keluargas_nama",
          "nik",
          "pasangan_id",
          "tempat_lahir",
          "tgl_lahir",
          "perkawinan_status_id",
          "jenis_kelamin",
          "pekerjaan",
          "agama_id",
          "file_path",
        ],
        arsip: [
          "arsip_kategori_id",
          "tgl",
          "nomor_arsip",
          "arsips_nama",
          "ket",
          "arsip_dewas_dewas_ids",
          "file_path",
        ],
        peringatan: [
          "no_peringatan",
          "tgl_peringatan",
          "no_pemeriksaan",
          "tgl_pemeriksaan",
          "jenis_hukuman",
          "peringatan",
          "file_path",
        ],
        penghargaan: ["nama", "nomor", "tgl", "pemberi", "ket", "file_path"],
      };
      return {
        items: [
          {
            itemType: "group",
            colCount: 2,
            colSpan: 2,
            items: tables[table] || [],
          },
        ],
      };
    },
    allowFileUpload() {
      var hasil = this.allow(this.can("pegawai-update"), this.allowUpdating);

      return hasil;
    },
    allow(var1, var2) {
      if (var1 && var2) return true;
      return false;
    },
    displayBoolean(data) {
      if (data === null || data == false) return "Tidak Aktif";
      return "Aktif";
    },
    displayTgl(tgl) {
      if (!tgl) return null;
      return formatDateDisplay(tgl);
    },
    displayCapeg(e) {
      if (e.value) {
        return "80%";
      }
    },
    displayTertanggung(e) {
      if (e.value) {
        return "Tertanggung";
      }
    },
    displayPenyesuaian(e) {
      if (e.data.status_penyesuaian) return "Penyesuaian";
      return "";
    },
    displayLookup(id, data) {
      const foundItem = _.find(data, { id: id });
      return foundItem && foundItem.nama ? foundItem.nama : "";
    },

    setPrintAdaFile(e) {
      if (_.isEmpty(e)) return false;
      else return true;
    },
    onEditingStart() {
      this.file = null;
      this.fileName = null;
      this.filePath = null;
    },

    hilangFilter() {
      // this.absenStore.onMuatButtonClick();
      this.buttonFilterPintasanVisible = false;
    },
    itemClick(e) {
      this.tabSource = this.tabMenus[e.itemData.templateIndex].items;
      this.treeData.forEach((item, index) => {
        //selected flag utk menu
        if (index == e.itemData.templateIndex) item.selected = true;
        else item.selected = false;
      });
    },

    resetFilter() {
      this.filterValue = [];

      this.$refs["dataGrid"].instance.getDataSource().reload();
    },

    can,

    async refreshDatagrid(gridRef) {
      this.$refs[gridRef].instance.getDataSource().reload();
    },

    onExporting(e, title) {
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet("Data Pegawai");

      exportDataGrid({
        component: e.component,
        worksheet,
        autoFilterEnabled: true,
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(
            new Blob([buffer], { type: "application/octet-stream" }),
            "Data " +
              this.pageTitle +
              this.dataSourceDewas.nama +
              " - " +
              title +
              ".xlsx",
          );
        });
      });
      e.cancel = true;
    },
  },
};
</script>

<style lang="scss" scoped>
/* .small-button-container {
  display: inline-block;
  padding: 0;
  margin: 0;
}

.small-button-container .dx-button {
  padding: 0;
  font-size: 12px;
} */
.formA {
  margin-left: 3px;
}

.formA > div:first-child {
  margin-right: 320px;
}

.label {
  font-size: 18px;
  font-weight: 500;
}

#product-details {
  width: 400px;
  height: 400px;
  margin: 20px auto 0;
}

#product-details > img {
  height: 300px;
  width: 400px;
}

#product-details > .name {
  text-align: center;
  font-size: 20px;
}

#product-details > .price {
  text-align: center;
  font-size: 24px;
}

.dark #product-details > div {
  color: #f0f0f0;
}

.options {
  padding: 20px;
  position: absolute;
  bottom: 0;
  right: 0;
  width: 260px;
  top: 0;
  background-color: rgba(191, 191, 191, 0.15);
}

.caption {
  font-size: 18px;
  font-weight: 500;
}

.option {
  margin-top: 10px;
}

.hidden {
  visibility: hidden;
}

// .dx-menu-item-selected {
//   background-color: rgba(0, 0, 0, 0.87) !important;
//   color: rgba(0, 0, 0, 0.87) !important;
// }

.title-container-pegawai {
  /* min-height: 100px; */
  margin-bottom: 10px;
  padding-bottom: 2px;
  padding-top: 15px;
}

.title-pegawai2 {
  /* padding: 0 0 20px 0; */
  /* padding-top: 70px; */
  padding: 1px;

  display: block;
  /* background-color: rgba(191, 191, 191, 0.15);
  background-clip: content-box; */
}

.job-history-title {
  font-size: 15px;
}

.flag-pegawai2 {
  float: left;
  height: 100px;
  width: 106px;
  margin: 0 10px 10px 0;
  border: 1px solid #d2d3d5;
  border-radius: 50%;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  background-color: #fff;
  overflow: hidden;
}

/* BATAS AWAL*/
.editors {
  margin-right: 200px;
  height: 570px;
}

.editors .left {
  padding: 0 10px 0 0;
}

.editors .right {
  padding: 0 0 0 10px;
}

.editors .left,
.editors .right {
  flex-grow: 1;
}

.editors .left > *,
.editors .right > *,
.editors .center > * {
  margin-bottom: 20px;
}

.editors .center {
  padding: 0 27px 0 0;
}

.validate {
  float: right;
}

.options-pegawai {
  display: inline-block;
  padding: 15px;
  position: absolute;
  bottom: 0;
  right: 0;
  width: 200px;
  top: 0;
  background-color: rgba(191, 191, 191, 0.15);
  box-shadow: -5px 0 14px -8px rgba(0, 0, 0, 0.25) inset;
}

.caption {
  font-size: 18px;
  font-weight: 500;
}

.option {
  margin-top: 20px;
}

.editors-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: 27px;
}
.title-container-pegawai {
  /* min-height: 100px; */
  margin-bottom: 10px;
  padding-bottom: 2px;
}

.title-container-pegawai .country-name {
  font-size: 240%;
  font-weight: bold;
  line-height: 34px;
  margin-bottom: 10px;
}

.title-container-pegawai > div:not(.flag-pegawai) {
  /* margin-left: 204px; */
  margin-left: 150px;
}

/* ASLI */
.flag-pegawai {
  height: 100px;
  width: 106px;
  margin: 0 10px 10px 0;
  border: 1px solid #d2d3d5;
  float: left;
  border-radius: 50%;
  /* background-image: url("LOGO.png"); */
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  overflow: hidden;
  background-color: #fff;
}

.table {
  border-collapse: collapse;
  /* width: 100%; */
}

/* .padded-column {
  padding-right: 100px;
} */
.table td:not(.padded-column) {
  border: none;
  padding-right: 15px;
  padding-top: 15px;
  padding-left: 15px;
  padding-bottom: 15px;
}

.padded-column {
  border: none;
  padding-right: 100px;
  padding-top: 15px;
  padding-left: 15px;
  padding-bottom: 15px;
}

.table th {
  background-color: #f0f0f0;
  font-weight: bold;
}
.button-container {
  /* float: right; */
  /* display: flex; */
  justify-content: space-between;
}

/* BATAS AKHIR*/
img {
  height: 100px;
  display: block;
  margin: 0 auto;
}
</style>
